<!--
 * @Description: 内部链接
 * @Autor: wangwangwang
 * @Date: 2021-05-24 16:11:56
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-05-24 17:48:31
-->
<template>
  <div class="pages_content table">
    <iframe :src="url" frameborder="0" style="height:100%;width:100%;"></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: '',
    }
  },
  watch: {
    $route: {
      handler(value) {
        this.url = value.query?.url;
      },
    }
  },
  mounted() {
    this.url = this.$route.query?.url;
  }
}
</script>

<style>

</style>